import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../firebase';
import { Loader2, ShieldAlert } from 'lucide-react';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [isOperator, setIsOperator] = useState<boolean | null>(null);

  useEffect(() => {
    if (loading) return;

    if (!user) {
      // Usuário não logado no Firebase: permite prosseguir para a tela de senha do Admin (Admin.tsx)
      setIsOperator(true);
      return;
    }

    // Check if user exists in 'operadores' collection
    const checkOperator = async () => {
      try {
        const docRef = doc(firestore, 'operadores', user.uid);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          setIsOperator(true);
        } else {
          // Permite que o usuário acesse a tela de Admin para colocar a senha master
          setIsOperator(true);
        }
      } catch (error) {
        console.error('Erro ao verificar permissão de operador:', error);
        // Em caso de erro (ex: falta de permissão), também permite prosseguir para a senha
        setIsOperator(true);
      }
    };

    checkOperator();
  }, [user, loading, navigate]);

  if (loading || isOperator === null) {
    return (
      <div className="min-h-[450px] flex flex-col items-center justify-center p-8 bg-white/60 rounded-3xl border border-slate-100 shadow-sm text-center">
        <Loader2 size={36} className="text-brand-blue animate-spin mb-3" />
        <p className="font-extrabold text-slate-800 text-sm">Verificando credenciais de segurança...</p>
        <p className="text-xs text-slate-400 mt-1">Acesso restrito</p>
      </div>
    );
  }

  if (isOperator) {
    return <>{children}</>;
  }

  return null;
}
